// IMPORTANT: THIS FILE IS AUTO GENERATED!

/**
 * Package version.
 */
exports.version = '6.1.0';

/**
 * Timestamp.
 */
exports.timestamp = '1750691144402';

/**
 * ISO date and time.
 */
exports.dateTime = '2025-06-23T15:05:44.402Z';

/**
 * Git hash.
 */
exports.gitHash = 'cb155a1fec2389b26c2da41f0cce15eab793f0db';

/**
 * Git short hash.
 */
exports.gitHashShort = 'cb155a1fe';

/**
 * Git tag name.
 */
exports.gitTag = 'v5.5.0';

/**
 * Git branch name.
 */
exports.gitBranch = 'release-6.0.9';
